"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

class EvaluationRequestEvaluee {
  static thaw(evaluationRequestEvalueeObj) {
    if (evaluationRequestEvalueeObj == null) return null;
    const evaluationRequestEvaluee = new EvaluationRequestEvaluee();
    if (evaluationRequestEvalueeObj.id != null) evaluationRequestEvaluee.setId(evaluationRequestEvalueeObj.id);
    if (evaluationRequestEvalueeObj.firstName != null) evaluationRequestEvaluee.setFirstName(evaluationRequestEvalueeObj.firstName);
    if (evaluationRequestEvalueeObj.lastName != null) evaluationRequestEvaluee.setLastName(evaluationRequestEvalueeObj.lastName);
    if (evaluationRequestEvalueeObj.email != null) evaluationRequestEvaluee.setEmail(evaluationRequestEvalueeObj.email);
    if (evaluationRequestEvalueeObj.phoneNumber != null) evaluationRequestEvaluee.setPhoneNumber(evaluationRequestEvalueeObj.phoneNumber);
    if (evaluationRequestEvalueeObj.segmentId != null) evaluationRequestEvaluee.setSegmentId(evaluationRequestEvalueeObj.segmentId);
    if (evaluationRequestEvalueeObj.addressId != null) evaluationRequestEvaluee.setAddressId(evaluationRequestEvalueeObj.addressId);
    if (evaluationRequestEvalueeObj.groupId != null) evaluationRequestEvaluee.setGroupId(evaluationRequestEvalueeObj.groupId);
    if (evaluationRequestEvalueeObj.evaluations != null) evaluationRequestEvaluee.setEvaluations(_.Evaluation.thawList(evaluationRequestEvalueeObj.evaluations));
    return evaluationRequestEvaluee;
  }

  static thawList(evaluationRequestEvalueeObjList) {
    if (evaluationRequestEvalueeObjList == null) return [];
    var evaluationRequestEvaluees = [];

    for (var i = 0; i < evaluationRequestEvalueeObjList.length; i++) {
      evaluationRequestEvaluees.push(EvaluationRequestEvaluee.thaw(evaluationRequestEvalueeObjList[i]));
    }

    return evaluationRequestEvaluees;
  }

  static freeze(evaluationRequestEvaluee) {
    if (evaluationRequestEvaluee == null) return null;
    var evaluationRequestEvalueeObj = {};
    if (evaluationRequestEvaluee.getId() != null) evaluationRequestEvalueeObj.id = evaluationRequestEvaluee.getId();
    if (evaluationRequestEvaluee.getFirstName() != null) evaluationRequestEvalueeObj.firstName = evaluationRequestEvaluee.getFirstName();
    if (evaluationRequestEvaluee.getLastName() != null) evaluationRequestEvalueeObj.lastName = evaluationRequestEvaluee.getLastName();
    if (evaluationRequestEvaluee.getEmail() != null) evaluationRequestEvalueeObj.email = evaluationRequestEvaluee.getEmail();
    if (evaluationRequestEvaluee.getPhoneNumber() != null) evaluationRequestEvalueeObj.phoneNumber = evaluationRequestEvaluee.getPhoneNumber();
    if (evaluationRequestEvaluee.getSegmentId() != null) evaluationRequestEvalueeObj.segmentId = evaluationRequestEvaluee.getSegmentId();
    if (evaluationRequestEvaluee.getAddressId() != null) evaluationRequestEvalueeObj.addressId = evaluationRequestEvaluee.getAddressId();
    if (evaluationRequestEvaluee.getGroupId() != null) evaluationRequestEvalueeObj.groupId = evaluationRequestEvaluee.getGroupId();
    if (evaluationRequestEvaluee.getEvaluations() != null) evaluationRequestEvalueeObj.evaluations = _.Evaluation.freezeList(evaluationRequestEvaluee.getEvaluations());
    return evaluationRequestEvalueeObj;
  }

  static freezeList(evaluationRequestEvaluees) {
    if (evaluationRequestEvaluees == null) return [];
    var evaluationRequestEvalueeObjList = [];

    for (var i = 0; i < evaluationRequestEvaluees.length; i++) {
      evaluationRequestEvalueeObjList.push(EvaluationRequestEvaluee.freeze(evaluationRequestEvaluees[i]));
    }

    return evaluationRequestEvalueeObjList;
  }

  constructor() {
    this.setId(null);
    this.setFirstName(null);
    this.setLastName(null);
    this.setEmail(null);
    this.setPhoneNumber(null);
    this.setSegmentId(null);
    this.setAddressId(null);
    this.setGroupId(null);
    this.setEvaluations(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setFirstName(firstName) {
    this.firstName = firstName;
  }

  setLastName(lastName) {
    this.lastName = lastName;
  }

  setEmail(email) {
    this.email = email;
  }

  setPhoneNumber(phoneNumber) {
    this.phoneNumber = phoneNumber;
  }

  setSegmentId(segmentId) {
    this.segmentId = segmentId;
  }

  setAddressId(addressId) {
    this.addressId = addressId;
  }

  setGroupId(group) {
    this.group = group;
  }

  setEvaluations(evaluations) {
    this.evaluations = evaluations;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  setId() {
    return id;
  }

  setFirstName() {
    return this.firstName;
  }

  setLastName() {
    return this.lastName;
  }

  setEmail() {
    return this.email;
  }

  setPhoneNumber() {
    return this.phoneNumber;
  }

  setSegmentId() {
    return this.segmentId;
  }

  setAddressId() {
    return this.addressId;
  }

  setGroupId() {
    return this.groupId;
  }

  setEvaluations() {
    return this.evaluations;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = EvaluationRequestEvaluee;